import React, { useEffect, useState } from 'react'
import PublicLayout from '../../layouts/PublicLayout'
import { Card } from 'flowbite-react'
import CustomInput from '../../components/CustomInputs/CustomInput'
import CustomButton from '../../components/CustomButton/CustomButton'
import Form from '../../components/Form/Form'
import { FaArrowRight } from 'react-icons/fa'
import * as styles from './completeLogin.styles'
import CustomLink from '../../components/CustomLinks/CustomLink'
import client from '../../api/client'
import { useLocation, useNavigate } from 'react-router-dom'
import showToast from '../../components/CustomToast/toastHelper'
import logo from '../../assets/Ideos.png'


const CompleteLogin = () => {
    const [otp, setOtp] = useState<string>()

    const [loading, setLoading] = useState<boolean>(false)
    const [allSet, setAllSet] = useState<boolean>(false)
    const navigate = useNavigate()
    const { state } = useLocation()
    const { email, message } = state

    useEffect(() => {
        if(otp?.length == 6){
            setAllSet(true)
        }else{
            setAllSet(false)
        }
    }, [otp])

    const handleSubmit = async (e: any) => {
        e.preventDefault()
        setLoading(true)
        const payload: any = {
            email: email,
            otp: otp
        }

        try {
            const response = await client.post("/subsidiary/dashboard/complete/login", payload);

            showToast(response.data.message, "success");
            sessionStorage.setItem("accessToken", response.data.token.accessToken)
            sessionStorage.setItem("refreshToken", response.data.token.refreshToken)
            sessionStorage.setItem("refreshExpires", response.data.token.refreshExpires)
            navigate('/overview');
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                console.log(err);

                console.error('error getting data', err);
                showToast(err.response.data.message, "error");
            }
        }
        finally{
            setLoading(false)
        }
    }
    return (
        <PublicLayout>
            <div className={styles.container}>
                {/* <div className='relative'> */}
                    <Card className={styles.card}>
                        <Form title="Complete sign in" subtitle="Please check your email for One-Time Password (OTP) to complete login request">
                            <div>
                                <div>
                                    <CustomInput type='number' value={otp} onChange={(e) => setOtp(e.target.value)} label='One-Time password (OTP)' name='otp' />
                                </div>
                                <CustomButton disabled={allSet== false} onClick={handleSubmit} loading={loading} className={styles.button} text='Complete Sign in ' icon={<FaArrowRight />} />

                                <div className={styles.buttomDiv}>
                                    <p className={styles.buttomDivPara}>Login with another account
                                        <CustomLink className={styles.link} to="/login" text=" Login" />
                                    </p>
                                </div>
                            </div>
                        </Form>

                    </Card>
                    {loading && (
                        <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/70">
                            <img src={logo} alt="Loading..." className="w-16 animate-spin" />
                        </div>
                    )}
                </div>
            {/* </div> */}
        </PublicLayout>
    )
}

export default CompleteLogin
